import React, { useCallback } from 'react';

import { ErrorDto } from 'lib_api/lib/api/gen';

import { useAlertMessage } from 'hooks/alertMessage/useAlertMessage';
import useDownloadFile from 'hooks/api/useDownloadFile';
import { useApi } from 'hooks/ApiStoreContext';
import { ExportStatistiquesForm } from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/form/ExportStatistiquesForm';
import { ExportStatistiquesFormValues } from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/types';
import { useValidateExportStatistiquesForm } from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/useValidateExportStatistiquesForm';
import { getErrorDtoOrThrow } from 'typeGuards/typeGuards';

import { CollapsableContainer } from '../CollapsableContainer';

import '../ActionCommon.less';

const ExportStatistiques = () => {
  const controller = useApi().AdminFonctionnelControllerApi;
  const initialValues: ExportStatistiquesFormValues = {
    dateDebut: undefined,
    dateFin: undefined,
  };
  const [formValues, setFormValues] =
    React.useState<ExportStatistiquesFormValues>(initialValues);
  const [formKey, setFormKey] = React.useState(0);
  const {
    alertMessage,
    setSuccessMessage,
    setErrorMessage,
    resetAlertMessage,
  } = useAlertMessage();

  const { mutateAsync, isPending } =
    useDownloadFile<ExportStatistiquesFormValues>(
      'export_statistiques.csv',
      (values: ExportStatistiquesFormValues) => {
        return controller.getExportStatistiquesUsingPOST({
          dateDebut: values.dateDebut || null,
          dateFin: values.dateFin || null,
        });
      },
    );

  const handleCancel = () => {
    setFormValues(initialValues);
    setFormKey(prev => prev + 1);
    resetAlertMessage();
  };

  function onChange(
    _: Partial<ExportStatistiquesFormValues>,
    allValues: ExportStatistiquesFormValues,
  ) {
    setFormValues(allValues);
    return allValues;
  }

  const validate = useValidateExportStatistiquesForm();

  const download = useCallback(
    (values: ExportStatistiquesFormValues) => {
      mutateAsync(values)
        .then(() =>
          setSuccessMessage(
            'Le téléchargement des statistiques est terminé avec succès.',
          ),
        )
        .catch(async (errorResponse: Response) => {
          const error: ErrorDto = getErrorDtoOrThrow(
            await errorResponse.json(),
          );
          setErrorMessage(
            `Erreur dans le téléchargement des statistiques : ${error.message}`,
          );
        });
    },
    [mutateAsync],
  );

  return (
    <CollapsableContainer
      title={'Export des statistiques'}
      alertMessage={alertMessage}
    >
      <ExportStatistiquesForm
        key={formKey}
        onSubmit={download}
        onChange={onChange}
        onCancel={handleCancel}
        inProgress={isPending}
        validate={validate}
        values={formValues}
      />
    </CollapsableContainer>
  );
};

export default ExportStatistiques;
